import type { GroupBase, OptionsOrGroups } from 'react-select';
import type { Team } from '@/lib/api/types/teams';

export interface TeamGroupLabels {
  inPortfolio: string;
  notInPortfolio: string;
}

export const buildGroupedTeamOptions = <TOption>(
  teams: Team[],
  loopId: number | undefined,
  mapTeam: (team: Team) => TOption,
  labels: TeamGroupLabels,
): OptionsOrGroups<TOption, GroupBase<TOption>> => {
  if (!loopId) {
    return teams.map(mapTeam);
  }

  const inPortfolio: TOption[] = [];
  const notInPortfolio: TOption[] = [];

  for (const team of teams) {
    if (team.loopId === loopId) {
      inPortfolio.push(mapTeam(team));
    } else if (team.loopId == null) {
      notInPortfolio.push(mapTeam(team));
    }
  }

  const groups: GroupBase<TOption>[] = [];
  if (inPortfolio.length > 0) {
    groups.push({ label: labels.inPortfolio, options: inPortfolio });
  }
  if (notInPortfolio.length > 0) {
    groups.push({ label: labels.notInPortfolio, options: notInPortfolio });
  }
  return groups;
};
